export default __webpack_public_path__ + "static/media/iconInstaColor.f5ee71bf.png";